import React from "react"
import { Textarea as CoreTextArea } from "@stardust-ds/react"

import styles from "./index.module.scss"
import Label from "../Label"
import MoveEllipsisIcon from "../../../assets/icons/MoveEllipsisIcon"

const RcmpTextArea = React.forwardRef((props, ref) => {
  const { label, bIsDraggable, bIsDisabled, style, fullHeight = true, ...oRest } = props
  return (
    <div className={`${styles.textAreaContainer} ${fullHeight ? styles.fullHeight: ''}`}>
      <div className={styles.containerDescrioption}>
        {bIsDraggable ? (
          <div className={styles.draggableComponent}>
            <MoveEllipsisIcon />
            <Label className={styles.label}>{label}</Label>
          </div>
        ) : (
          <Label className={styles.label}>{label}</Label>
        )}
        <CoreTextArea
          disabled={bIsDisabled}
          ref={ref}
          {...oRest}
          style={{ border: "1px solid red !important", ...style }}
        />
      </div>
    </div>
  )
})

export default RcmpTextArea
